import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { ProgramsPage } from './pages/ProgramsPage';
import { KidsMartialArtsPage } from './pages/programs/KidsMartialArtsPage';
import { TeenAdultClassesPage } from './pages/programs/TeenAdultClassesPage';
import { BrazilianJiuJitsuPage } from './pages/programs/BrazilianJiuJitsuPage';
import { CompetitionTeamPage } from './pages/programs/CompetitionTeamPage';
import { BlackBeltClubPage } from './pages/BlackBeltClubPage';
import { LocationsPage } from './pages/LocationsPage';
import { InstructorsPage } from './pages/InstructorsPage';
import { FormsVideosPage } from './pages/FormsVideosPage';
import { FAQsPage } from './pages/FAQsPage';
import { ContactPage } from './pages/ContactPage';
import { MerchPage } from './pages/MerchPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { MidlandPage } from './pages/locations/MidlandPage';
import { SaginawPage } from './pages/locations/SaginawPage';
import { CaroPage } from './pages/locations/CaroPage';
import { BridgeportPage } from './pages/locations/BridgeportPage';
import { HemlockPage } from './pages/locations/HemlockPage';
import { BayCityPage } from './pages/locations/BayCityPage';
function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/programs" element={<ProgramsPage data-id="element-6" />} data-id="element-5" />
        <Route path="/programs/kids-martial-arts" element={<KidsMartialArtsPage data-id="element-8" />} data-id="element-7" />
        <Route path="/programs/teen-adult-classes" element={<TeenAdultClassesPage data-id="element-10" />} data-id="element-9" />
        <Route path="/programs/brazilian-jiu-jitsu" element={<BrazilianJiuJitsuPage data-id="element-12" />} data-id="element-11" />
        <Route path="/programs/competition-team" element={<CompetitionTeamPage data-id="element-14" />} data-id="element-13" />
        <Route path="/black-belt-club" element={<BlackBeltClubPage data-id="element-16" />} data-id="element-15" />
        <Route path="/locations" element={<LocationsPage data-id="element-18" />} data-id="element-17" />
        <Route path="/locations/midland" element={<MidlandPage data-id="element-20" />} data-id="element-19" />
        <Route path="/locations/saginaw" element={<SaginawPage data-id="element-22" />} data-id="element-21" />
        <Route path="/locations/caro" element={<CaroPage data-id="element-24" />} data-id="element-23" />
        <Route path="/locations/bridgeport" element={<BridgeportPage data-id="element-26" />} data-id="element-25" />
        <Route path="/locations/hemlock" element={<HemlockPage data-id="element-28" />} data-id="element-27" />
        <Route path="/locations/bay-city" element={<BayCityPage data-id="element-30" />} data-id="element-29" />
        <Route path="/instructors" element={<InstructorsPage data-id="element-32" />} data-id="element-31" />
        <Route path="/forms-videos" element={<FormsVideosPage data-id="element-34" />} data-id="element-33" />
        <Route path="/faqs" element={<FAQsPage data-id="element-36" />} data-id="element-35" />
        <Route path="/contact" element={<ContactPage data-id="element-38" />} data-id="element-37" />
        <Route path="/merch" element={<MerchPage data-id="element-40" />} data-id="element-39" />
        <Route path="/merch/:productId" element={<ProductDetailPage data-id="element-42" />} data-id="element-41" />
      </Routes>
    </Router>;
}
export { App };